// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Router from "next/router";
import * as AuthStore$PorterinFeature from "../../../domain/store/AuthStore.mjs";
import * as AuthUtils$PorterinFeature from "../../../domain/helpers/AuthUtils.mjs";
import * as AuthConfig$PorterinFeature from "../../../domain/config/AuthConfig.mjs";
import * as AuthLayout$PorterinFeature from "../common/AuthLayout.mjs";
import * as AuthTextCmp$PorterinFeature from "../common/AuthTextCmp.mjs";
import * as ResendOtpCmp$PorterinFeature from "../resend-otp/ResendOtpCmp.mjs";
import * as AuthContextV1$PorterinFeature from "../../../view-model/contexts/auth-context/AuthContextV1.mjs";
import * as CategoryAnalytics$PorterinFeature from "../../../../fare-estimate-v1/domain/helpers/CategoryAnalytics.mjs";
import * as ResendOtpTimerCmp$PorterinFeature from "./ResendOtpTimerCmp.mjs";
import * as ChangeOtpNumberCmp$PorterinFeature from "./ChangeOtpNumberCmp.mjs";
import * as AuthWrapperModuleScss from "../../styles/AuthWrapper.module.scss";
import * as OtpValidationFormCmp$PorterinFeature from "./form/OtpValidationFormCmp.mjs";
import * as CommonAnalyticsHelper$PorterinFeature from "../../../../../shared/core/helpers/CommonAnalyticsHelper.mjs";
import * as FareEstimateAnalyticsHelper$PorterinFeature from "../../../../fare-estimate-v1/domain/helpers/FareEstimateAnalyticsHelper.mjs";

var styles = AuthWrapperModuleScss;

function OtpValidationCmp(Props) {
  var set_auth_state = Props.set_auth_state;
  var close_modal = Props.close_modal;
  var is_modal = Props.is_modal;
  var is_change_number_cta_visiableOpt = Props.is_change_number_cta_visiable;
  var close_on_successOpt = Props.close_on_success;
  var is_change_number_cta_visiable = is_change_number_cta_visiableOpt !== undefined ? is_change_number_cta_visiableOpt : true;
  var close_on_success = close_on_successOpt !== undefined ? close_on_successOpt : true;
  var match = React.useState(function () {
        return AuthConfig$PorterinFeature.resend_otp_timer;
      });
  var setSeconds = match[1];
  var seconds = match[0];
  var match$1 = React.useState(function () {
        return 0;
      });
  var setResendOtpCount = match$1[1];
  var resendOtpCount = match$1[0];
  var match$2 = React.useState(function () {
        return /* OtpValidation */0;
      });
  var setOtpState = match$2[1];
  var router = Router.useRouter();
  var match$3 = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var user = match$3.user;
  React.useEffect((function () {
          var timeout_id = setTimeout((function (param) {
                  CommonAnalyticsHelper$PorterinFeature.publishPageLandEventWithParameter(CategoryAnalytics$PorterinFeature.getCategoryName(router), AuthStore$PorterinFeature.OtpValidation.ga_page_landing, AuthStore$PorterinFeature.OtpValidation.moe_page_landing_parameter, FareEstimateAnalyticsHelper$PorterinFeature.getFareSelectedCardVersionEventPayload(AuthUtils$PorterinFeature.mobile(user)));
                }), 0);
          return (function (param) {
                    clearTimeout(timeout_id);
                  });
        }), []);
  React.useEffect((function () {
          var intervalId = setInterval((function (param) {
                  Curry._1(setSeconds, (function (prevSeconds) {
                          return prevSeconds - 1 | 0;
                        }));
                }), 1000);
          if (seconds === 0) {
            clearInterval(intervalId);
          }
          return (function (param) {
                    clearInterval(intervalId);
                  });
        }), [seconds]);
  React.useEffect((function () {
          Curry._1(setSeconds, (function (param) {
                  return 10;
                }));
        }), [resendOtpCount]);
  if (match$2[0]) {
    return React.createElement(AuthLayout$PorterinFeature.make, {
                children: React.createElement(ResendOtpCmp$PorterinFeature.make, {
                      set_otp_state: setOtpState,
                      is_desktop: true,
                      close_modal: (function (val) {
                          Curry._1(close_modal, undefined);
                        }),
                      resend_count: resendOtpCount,
                      set_resend_count: setResendOtpCount
                    }),
                show_header: false,
                is_modal: is_modal,
                close_modal: close_modal
              });
  } else {
    return React.createElement("div", {
                className: styles.wrapper
              }, React.createElement(AuthTextCmp$PorterinFeature.make, {
                    heading: AuthStore$PorterinFeature.OtpValidation.heading,
                    sub_heading: undefined
                  }), is_change_number_cta_visiable ? React.createElement(ChangeOtpNumberCmp$PorterinFeature.make, {
                      set_auth_state: set_auth_state
                    }) : null, React.createElement(OtpValidationFormCmp$PorterinFeature.make, {
                    close_modal: close_modal,
                    close_on_success: close_on_success
                  }), React.createElement(ResendOtpTimerCmp$PorterinFeature.make, {
                    set_otp_state: setOtpState,
                    resend_count: resendOtpCount,
                    seconds: seconds,
                    set_resend_count: setResendOtpCount
                  }));
  }
}

var make = OtpValidationCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
